import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup } from '@angular/forms';
import { ConfirmDialogComponent } from '../../dialog/confirm-dialog/confirm-dialog.component';
import { SubscriptionEditComponent } from '../subscription-edit/subscription-edit.component';
import { Subscription } from 'src/app/classes/Subscription';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { SubscriptionType } from 'src/app/enums/SubscriptionType';

@Component({
  selector: 'app-subscription-list',
  styleUrls: ['./subscription-list.component.scss'],
  templateUrl: './subscription-list.component.html'
})
export class SubscriptionListComponent implements OnInit {

  public subscriptions: Subscription[];
  public errorMessage: string;
  private currentDialog = null;
  private subscriptionType = SubscriptionType;

  constructor(private subscriptionService: SubscriptionService,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.refreshList();
  }

  refreshList(): void {
    this.subscriptionService.getAll().subscribe({
      next: (subscriptions) => {
        this.subscriptions = subscriptions;
      },
      error: (error) => this.errorMessage = error.error.error
    });
  }

  openEditModal(subscription: Subscription): void {
    this.currentDialog = this.modalService.open(SubscriptionEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-subscription-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.subscription = subscription;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedSubscription = new Subscription(result.value);
          if ((editedSubscription.subscriptionType as any).value === this.subscriptionType.EVENT) {
            editedSubscription.createCampRequest.prices = editedSubscription.createCampRequest.prices.filter(p => p.selected).map(p => ({
              amount: p.amount,
              periodCount: p.periodCount,
            }));
            if (editedSubscription.id) {
              editedSubscription.camp = {...editedSubscription.createCampRequest};
              delete editedSubscription.createCampRequest;
            }
          } else {
            delete editedSubscription.createCampRequest;
          }
          delete editedSubscription.subscriptionType;
          this.subscriptionService.createOrEdit(editedSubscription).subscribe({
            next: () => this.refreshList(),
            error: (error) => {
              if (error.error && error.error.message) {
                this.errorMessage = error.error.message;
              } else {
                this.errorMessage = 'An unexpected error occurred';
              }
            }
          });
        }
      },
      (error) => {
        console.log('Dialog close error: ' + error);
      }
    );
  }

  openDeleteConfirmModal(subscription: Subscription): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-subscription-delete-confirm',
        size: 'md',
        centered: true,
      });

    this.currentDialog.componentInstance.isConfirmCheckBoxLabel = 'Delete completely';
    this.currentDialog.componentInstance.isConfirmCheckbox = true;
    this.currentDialog.componentInstance.message =
      'Are you sure that you want delete subscription with id ' + subscription.id + '?';

    this.currentDialog.result.then((result: any) => {
      if (result.status === 'confirmed') {
        this.subscriptionService.delete(subscription.id, result.checkboxValue).subscribe({
          next: () => this.refreshList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  public getSubscriptionType(subscription: Subscription): string {
    if (subscription.bundleId === null && subscription.camp === null) {
      return 'Regular';
    }
    if (subscription.bundleId === null) {
      return 'Event';
    }
    return 'Course';
  }

}
